/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useMemo } from "react";

const useNormalizedButtonList = (component) => {
    return useMemo(() => {
        if (component?.button_list?.length > 0) {
            return component.button_list;
        }

        // Convert old data format to new button list format
        const style = component?.style;
        const colour = component?.colour;
        const icon = component?.icon;
        const link = component?.link;

        if (style || colour || icon || link) {
            return [
                {
                    style,
                    colour,
                    icon,
                    link
                }
            ];
        }

        return [];
    }, [component]);
};

export { useNormalizedButtonList };
